import React from 'react';

const PlanUsageSwitch = () =>
  <div className="plan-usage-toggle">
    <form className="plan-usage-form">
      <div
        className="switch-group"
        data-toggle="tooltip"
        data-placement="top"
        data-container="body"
        title="You should choose this option if it will be external people the ones who will authenticate against the applications and APIs you've created or acquired."
      >
        <input id="external" type="radio" name="usage" value="external" defaultChecked />
        <label htmlFor="external"><span className="only-tooltip"> External</span></label>
      </div>
      <div
        className="switch-group"
        data-toggle="tooltip"
        data-placement="top"
        data-container="body"
        title="You should choose this option if it will be your company employees the ones who will authenticate against the applications and APIs you've created or acquired."
      >
        <input id="internal" type="radio" name="usage" value="internal" />
        <label htmlFor="internal"><span className="only-tooltip"> Internal</span></label>
      </div>
    </form>
  </div>;

export default PlanUsageSwitch;



// WEBPACK FOOTER //
// ./src/components/pricingPlans/components/planBox/PlanUsageSwitch.js